export default function scrollUp() {
  return window.scrollTo(0, 0);
}
